// API Configuration
export const API_URL = 'https://app.forloop.ai:8001';

// For local development, uncomment the line below and comment out the line above
//export const API_URL = 'http://localhost:8000';

// Mirror websites app (used in Product Detail View links and EmbeddedAppView)
export const MIRROR_WEBSITES_BASE_URL = `http://app.forloop.ai:8002`;

export const COLOR_PALETTE = {
  regions: {
    WE: '#81B1EB',
    EE: '#01B18A',
    MENEAT: '#FF6201',
    'N.ASIA': '#5B47B8',
    'S.ASIA': '#C41863',
    AMERICAS: '#FFCC00',
  },
  categories: {
    COMBUSTIBLES: '#816F69',
    RRP: '#2D4A60',
    RMC: '#816F69',
    FCT: '#EA5850',
    HTS: '#2D4A60',
    'E-VAPE': '#A83AE8',
    'MODERN ORAL': '#6BC7EF',
    OTHERS: '#A6A6A6',
  },
  manufacturers: {
    JTI: '#00BB31',
    PMI: '#0594FF',
    BAT: '#24336B',
    ITG: '#BD785D',
    'KT&G': '#C00000',
    OTHERS: '#A6A6A6',
  },
  brands: {
    PLOOM: '#002F3B',
    IQOS: '#02B7BD',
    GLO: '#F26820',
    PULZE: '#BD785D',
    LIL: '#9128E0',
    OTHERS: '#A6A6A6',
  },
  flavors: {
    TOBACCO: '#A36100',
    MENTHOL: '#346F40',
    'REGULAR FRESH': '#82C48F',
    'REGULAR SENSORIAL': '#FF9933',
    'MENTHOL PROGRESSIVE': '#971D4C',
    'REGULAR PROGRESSIVE': '#DC4880',
  },
  aggregatedFlavors: {
    FRUITY: '#9789FB',
    'CFB BLEND': '#53E618',
    HNS: '#2857A1',
  },
  generations: {
    'Gen 4': '#A7F1D7',
    'Gen 3': '#5C5C5C',
  },
  brandProducts: {
    PLOOM: {
      core: {
        EVO: '#BA3A7D',
        CAMEL: '#F9CF1F',
        WINSTON: '#1185E5',
        SOBRANIE: '#0E0E0E',
        MEVIUS: '#001788',
      },
    },
    IQOS: {
      core: {
        TEREA: '#1CBFCE',
        HEETS: '#929292',
        DELIA: '#A90319',
        LEVIA: '#7ADA60',
      },
      secondary: {
        BLENDS: '#F5B1AD',
        AXIA: '#EDC7DB',
        SENTIA: '#DCCDFB',
      },
    },
    GLO: {
      core: {
        NEO: '#D1A769',
        VEO: '#EA5850',
        KENT: '#7C82D6',
      },
      secondary: {
        'LUCKY STRIKE': '#FFD097',
        DUNHILL: '#8DB2BF',
        VOGUE: '#C6868C',
        PARISIENNE: '#BDFF81',
      },
    },
    PULZE: {
      core: {
        ID: '#BD785D',
        ISENZIA: '#FD9345',
      },
    },
    LIL: {
      core: {
        FIIT: '#9128E0',
        MIIX: '#02898E',
        AIIM: '#7BCB9B',
      },
    },
  },
};

/** Heated tobacco sticks (HTS) vs heated non-tobacco sticks (HNS) — product line keywords for title matching. */
export const STICK_CATEGORY_HTS_LINES = ['HEETS', 'TEREA', 'DELIA', 'NEO', 'VIRTO', 'EVO'];
export const STICK_CATEGORY_HNS_LINES = ['VEO', 'RIVO', 'LYO'];

/** Matching group names (normalized lowercase) mapped to stick category. */
export const STICK_CATEGORY_HTS_GROUP_NAMES = new Set(
  STICK_CATEGORY_HTS_LINES.map((line) => line.toLowerCase())
);
export const STICK_CATEGORY_HNS_GROUP_NAMES = new Set(
  STICK_CATEGORY_HNS_LINES.map((line) => line.toLowerCase())
);

/** Variant group names in matching metadata that hold an explicit HNS/HTS assignment. */
export const STICK_CATEGORY_VARIANT_GROUP_NAMES = [
  'hns / hts',
  'hns/hts',
  'stick category',
  'stick type',
];

export const STICK_CATEGORY_FILTER_OPTIONS = ['All', 'HTS', 'HNS', 'Other'];